import getVWKey from "../../../../../Q3/helpers/getVWKey";

export default new class LimitsCtl {

    get controls() {
        if (Q3.controls === Q3.objectRotationControls) {
            return Q3.physicalCameraControls;
        } else {
            return Q3.controls;
        }
    }

    isControlEvent(event) {
        if (Q3.controls === Q3.objectRotationControls) {
            return event.ctrlKey || event.key === "Control";
        } return event.key === "Control";
    }

    disableLimits() {
        const _1deg = THREE.Math.DEG2RAD;

        this.controls.minAzimuthAngle = -Infinity;
        this.controls.maxAzimuthAngle = Infinity;
        this.controls.minDistance = 0;
        this.controls.maxDistance = Infinity;
        this.controls.minPolarAngle = _1deg;
        this.controls.maxPolarAngle = Math.PI - _1deg;
        this.controls.setPanLimits();
        this.controls.enabled = true;
    }

    reEnableLimits(slide) {
        const currentSlide = Q3.data.slides[slide];
        const cameraData = this.getLayoutLimits(slide);

        ["Distance", "AzimuthAngle", "PolarAngle"].forEach(limit => {
            const enabled = cameraData[this.getCameraLimitEnableParam(limit)];

            if (enabled) this.toggleCameraLimits(limit, true, slide);
        });

        if (cameraData.panLimitEnabled)
            this.toggleCameraPanLimit(true, slide);

        if (Q3.controls === Q3.objectRotationControls) {
            Q3.controls.enabled = !Boolean(currentSlide.camera.disabled);
        } else {
            Q3.controls._enabled = !Boolean(currentSlide.camera.disabled)
        }
    }

    getCameraLimitEnableParam(paramName) {
        switch (paramName) {
            case 'Distance': return 'zoomLimitEnabled';
            case 'AzimuthAngle': return 'horizontalAngleLimitEnabled';
            case 'PolarAngle': return 'verticalAngleLimitEnabled';
        }
    }

    getValidSlide(slide) {
        return slide !== undefined ? slide : Q3.SlideManager.activeSlide;
    }

    getCameraLimitsMid(paramName, slide) {
        slide = this.getValidSlide(slide);

        const minParamName = 'min' + paramName, maxParamName = 'max' + paramName;
        const cameraData = this.getLayoutLimits(slide);

        return (cameraData[minParamName] + cameraData[maxParamName]) * 0.5;
    }

    getCameraLimitsSpread(paramName, slide) {
        slide = this.getValidSlide(slide);

        const minParamName = 'min' + paramName, maxParamName = 'max' + paramName;
        const cameraData = this.getLayoutLimits(slide);

        return (cameraData[maxParamName] - cameraData[minParamName]) * 0.5;
    }

    setCameraLimitsMinMax(paramName, minVal, maxVal, slide) {
        const minParamName = 'min' + paramName, maxParamName = 'max' + paramName;
        const cameraData = this.getLayoutLimits(slide);

        cameraData[minParamName] = minVal;
        cameraData[maxParamName] = maxVal;
    }

    applyCameraLimitsToCamera(paramName) {
        const enableParamName = this.getCameraLimitEnableParam(paramName);
        const cameraData = this.getLayoutLimits(Q3.SlideManager.activeSlide);

        if (cameraData[enableParamName]) {
            let minParamName = 'min' + paramName, maxParamName = 'max' + paramName;
            let minVal = cameraData[minParamName], maxVal = cameraData[maxParamName];

            if (paramName === 'AzimuthAngle') {
                let spreadVal = (maxVal - minVal) * 0.5;
                if (spreadVal > 179.99) {
                    spreadVal = 179.99;
                    let midVal = (minVal + maxVal) * 0.5;
                    minVal = midVal - spreadVal;
                    maxVal = midVal + spreadVal;
                }
            }

            if (paramName === 'AzimuthAngle' || paramName === 'PolarAngle') {
                minVal *= Math.PI / 180;
                maxVal *= Math.PI / 180;
            }

            this.controls[minParamName] = minVal;
            this.controls[maxParamName] = maxVal;
        } else {
            switch (paramName) {
                case 'Distance':
                    this.controls.minDistance = 0;
                    this.controls.maxDistance = Infinity;
                    break;
                case 'AzimuthAngle':
                    this.controls.minAzimuthAngle = -Infinity;
                    this.controls.maxAzimuthAngle = Infinity;
                    break;
                case 'PolarAngle':
                    const _1deg = THREE.Math.DEG2RAD;
                    this.controls.minPolarAngle = _1deg;
                    this.controls.maxPolarAngle = Math.PI - _1deg;
                    break;
            }
        }
    }

    applyCameraToCameraLimits(paramName) {
        let midVal = this.getCurrentCameraParam(paramName);
        let spreadVal = this.getCameraLimitsSpread(paramName);

        this.setCameraLimitsMinMax(paramName, midVal - spreadVal, midVal + spreadVal, Q3.SlideManager.activeSlide);
    }

    setCameraLimitsEnabled(paramName, enabled, slide) {
        const enableParamName = this.getCameraLimitEnableParam(paramName);
        const cameraData = this.getLayoutLimits(slide);

        cameraData[enableParamName] = enabled;
    }

    getCurrentCameraParam(paramName) {
        let spherical = new THREE.Spherical();
        this.controls.getSphericalCoordinates(spherical);

        if (paramName === 'Distance') {
            return spherical.radius;
        } else if (paramName === 'AzimuthAngle') {
            return spherical.theta * 180 / Math.PI;
        } else if (paramName === 'PolarAngle') {
            return spherical.phi * 180 / Math.PI;
        }
    }

    setCameraLimitsSpread(paramName, spreadVal, slide) {
        let midVal = this.getCameraLimitsMid(paramName, slide);
        this.setCameraLimitsMinMax(paramName, midVal - spreadVal, midVal + spreadVal, slide);
    }

    toggleCameraLimits(paramName, val, slide) {
        slide = this.getValidSlide(slide);
        this.setCameraLimitsEnabled(paramName, val, slide);

        if (slide === Q3.SlideManager.activeSlide) {
            if (val) {
                this.applyCameraToCameraLimits(paramName);
            }

            this.applyCameraLimitsToCamera(paramName);

        }
    }

    changeCameraLimitsSpread(paramName, spreadVal, slide) {
        slide = this.getValidSlide(slide);
        this.setCameraLimitsSpread(paramName, spreadVal, slide);

        if (slide === Q3.SlideManager.activeSlide) {
            this.applyCameraLimitsToCamera(paramName);
        }
    }

    toggleCameraPanLimit(objectUuid, val, slide) {
        slide = this.getValidSlide(slide);

        const cameraData = Q3.LimitManager.getObjectCameraLimits(slide, objectUuid);
        cameraData.panLimitEnabled = val;

        if (slide === Q3.SlideManager.activeSlide) {
            if (val) {
                Object.assign(cameraData.panLimits.center, this.controls.target);
                let { x, y, z, w } = this.controls.object.quaternion;
                Object.assign(cameraData.panLimits.quaternion, { x, y, z, w });
            }

            this.applyCameraPanLimitToCamera();
        }
    }

    getLayoutLimits(slide) {
        const slideData = Q3.data.slides[slide];
        const cameraLimits = slideData.cameraLimits;

        const vpType = getVWKey();
        const cameraData = vpType === "sizeSm"
            ? cameraLimits[vpType] = cameraLimits[vpType] || JSON.parse(JSON.stringify(cameraLimits))
            : cameraLimits;

        return cameraData;
    }

    changeCameraPanLimitSpread(spreadVal, slide) {
        slide = this.getValidSlide(slide);

        const cameraData = this.getLayoutLimits(slide);

        cameraData.panLimits.offset = spreadVal;

        if (slide === Q3.SlideManager.activeSlide) {
            this.applyCameraPanLimitToCamera();
        }
    }

    applyCameraPanLimitToCamera() {
        const cameraData = this.getLayoutLimits(Q3.SlideManager.activeSlide);

        if (cameraData && cameraData.panLimitEnabled && cameraData.panLimits.offset > 0) {
            const panLimits = cameraData.panLimits;
            this.controls.setPanLimits(panLimits.center, panLimits.quaternion, panLimits.offset);
        } else this.controls.setPanLimits();

        if (cameraData && Q3.physicalCameraControls === Q3.controls)
            this.controls.enablePan = !cameraData.panLimitEnabled;
    }

    toggleCameraControls(value, slide) {
        slide = this.getValidSlide(slide);

        Q3.SlideManager
            .getSlide(slide)
            .camera
            .disabled = value;

        if (!slide)
            Q3.controls._enabled = !value;
    }

    toggleObjectScaleLimit(objectUuid, value, slide) {
        slide = this.getValidSlide(slide);

        Q3.LimitManager
            .getObjectCameraLimits(slide, objectUuid)
            .objectScaleLimitEnabled = value;
    }

    setObjectScaleLimit(objectUuid, value, slide) {
        slide = this.getValidSlide(slide);

        Q3.LimitManager
            .getObjectCameraLimits(slide, objectUuid)
            .objectScaleLimit = value;
    }

}